import React from "react";

// Fixed semantic colors (independent of the app theme), matching the
// live / staging / awaiting / draft states used across sites, changes,
// and deployments.
const VARIANT_STYLES = {
  success: "bg-[#e2f2e6] text-[#2f7d4f]",
  warning: "bg-[#f7e4d0] text-[#a15211]",
  info: "bg-[#e8edfb] text-[#3d5fce]",
  neutral: "bg-theme-secondary text-theme-secondary-text",
  danger: "bg-[#fdf5f4] text-[#b3261e]",
};

const STATUS_VARIANTS = {
  live: "success",
  published: "neutral",
  deployed: "neutral",
  approved: "success",
  active: "success",
  ready: "success",
  processing: "warning",
  provisioning: "warning",
  verified: "success",
  staging: "warning",
  building: "warning",
  deploying: "warning",
  cloning_repo: "warning",
  editing: "warning",
  preview_ready: "warning",
  pending: "warning",
  pending_verification: "warning",
  awaiting_approval: "info",
  draft: "neutral",
  superseded: "neutral",
  paused: "neutral",
  archived: "neutral",
  rolled_back: "neutral",
  canceled: "neutral",
  not_configured: "neutral",
  failed: "danger",
  rejected: "neutral",
};

const humanize = (status) => {
  if (!status) return "";
  if (status === "completed") return "Ready";
  const text = status.replace(/_/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const StatusBadge = ({ status, label, variant }) => {
  if (status === "superseded") return null;
  const text = label || humanize(status);
  if (!text) return null;
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
        VARIANT_STYLES[variant || STATUS_VARIANTS[status] || "neutral"]
      }`}
    >
      {text}
    </span>
  );
};

export default StatusBadge;
